import { defineComponent as _defineComponent } from 'vue'
import { nextTick, ref } from 'vue'
import { InputIrmao } from '@/../common/types/Irmao'
import { storageFotoIrmaoRef } from '@/../common/shareds/sharedsIrmao'
import IrmaoService from '@/services/IrmaoService'
import { criarIrmao } from '@/shareds/sharedsIrmao'
import TableFilhos from './TableFilhos.vue'
import FormPerfil from './FormPerfil.vue'
import FormGeral from './FormGeral.vue'
import FormEsposa from './FormEsposa.vue'
import FormLojas from './FormLojas.vue'
import moment from 'moment'
import { authModule, alert, userModule } from '@/store'
import { v4 as uuidv4 } from 'uuid'
import { storage } from '@/firebase'
import { intersectRoles } from '@/helpers/auth-helpers'
import TableTelefones from './TableTelefones.vue'
import FormSeguranca from './FormSeguranca.vue'
import { onBeforeRouteLeave, useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormIrmao',
  props: {
	id: { default: undefined, type: String },
	novo: { default: false, type: Boolean },
},
  setup(__props) {

const props = __props;



const router = useRouter()

const versaoAnterior = ref<string | null>(null)
const carregando = ref(true)
const erro = ref<string | null>(null)
const irmao = ref<InputIrmao | null>(null)

const salvando = ref(false)

const form = ref<HTMLFormElement & {
	validate: (() => boolean),
}>()

const novaFoto = ref<File | null>(null)

async function carregarIrmao() {
	try {
		if (!userModule.currentUser)
			throw new Error('Nenhum usuário logado')

		if (userModule.currentUser?.role === 'Visitante')
			throw new Error('Visitante não tem acesso a esse formulário')

		erro.value = null
		carregando.value = true
		irmao.value = props.novo
			? criarIrmao(userModule.currentUser)
			: await IrmaoService.get(props.id!).then((irmao) => ({
				...irmao,
				senha: '',
				potencia: irmao.potencia._id,
				loja: irmao.loja._id,
				somar: irmao.somar?._id || null,
				esposa: irmao.esposa || null,
				lojas: irmao.lojas.map(loja => ({
					...loja,
					loja: loja.loja._id,
				})),
			}))
		nextTick().then(() => {
			versaoAnterior.value = JSON.stringify(irmao.value)
		})
	} catch (error) {
		erro.value = (error as any).message
	} finally {
		nextTick(() => {
			carregando.value = false
		})
	}
}

carregarIrmao()

async function salvar() {
	if (!irmao.value) return
	try {
		salvando.value = true

		const irmaoParaSalvar = await beforeSave(irmao.value)
		if (!irmaoParaSalvar) return

		const irmaoSalvo = props.novo
			? await IrmaoService.post(irmaoParaSalvar)
			: await IrmaoService.put(props.id!, irmaoParaSalvar)
		if (props.novo && irmaoSalvo.email)
			avisarConvite(irmaoSalvo as { email?: string, conviteEnviado?: boolean })
		versaoAnterior.value = JSON.stringify(irmao.value)
		router.push({
			name: 'detalhar-irmao',
			params: {
				id: irmaoSalvo._id,
			},
		})
	} catch (error) {
		alert.setError(error)
	} finally {
		salvando.value = false
	}
}

function avisarConvite({ email, conviteEnviado }: { email?: string, conviteEnviado?: boolean }) {
	if (conviteEnviado) alert.setSuccess(`Link para definir a senha enviado para ${email}`)
	else alert.setError('Irmão salvo, mas o e-mail com o link de senha não foi enviado. Reenvie pela seção Privacidade e Segurança.')
}

async function beforeSave(irmaoAtual: InputIrmao) {
	if (!irmao.value) return
	if (!form.value!.validate()) return
	const irmaoAlterado = {
		...irmaoAtual,
		ultimaAtualizacao: moment().toISOString(true),
	}

	if (novaFoto.value) {
		const ref = storage.ref(`${storageFotoIrmaoRef}/${uuidv4()}`)
		const snapshot = await ref.put(novaFoto.value, {
			customMetadata: {
				fileName: novaFoto.value.name,
			},
		})
		const donwloadUrl = await snapshot.ref.getDownloadURL()
		irmaoAlterado.foto = donwloadUrl
	}

	return irmaoAlterado
}

function validarSaida(): false | void {
	if(versaoAnterior.value === JSON.stringify(irmao.value)) return
	return confirm("Alguns dados não foram salvos. Deseja mesmo sair?") && undefined
}

onBeforeRouteLeave((to, from, next) => {
	next(validarSaida())
})

return { __sfc: true,props, router, versaoAnterior, carregando, erro, irmao, salvando, form, novaFoto, carregarIrmao, salvar, avisarConvite, beforeSave, validarSaida, TableFilhos, FormPerfil, FormGeral, FormEsposa, FormLojas, TableTelefones, FormSeguranca }
}

})